import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RedirectToHome from '../../components/RedirectToHome';
import PersonalDataHeader from './SettingsHeader';
import { routes } from './SettingsHeader/routes';

const Content: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Switch>
    {Object.values(routes()).map(({ render, route }, i) => (
      <Route
        key={i}
        exact={true}
        path={route.template()}
        render={() => render()}
      />
    ))}
    <Route path="*">
      <RedirectToHome />
    </Route>
  </Switch>
);

const Settings: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <PersonalDataHeader />
      <Content />
    </>
  );
};

export default Settings;
